import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/manage/page', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/vehicle/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/park/vehicle/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/vehicle/save/v2', params, options);

export const addCarMonth = (params, options) =>
  request.post('/api/v4ward/car/CarMonth/save/v2', params, options);

export const addCarMonthNew = (params, options) =>
  request.post('/api/v4ward/monthcar/v1/add/v2', params, options);

export const update = (params, options) =>
  request.post('/api/park/vehicle/update/v2', params, options);

export const syncVehicles = (params, options) =>
  request.post('/api/park/vehicle/sync/v2', qs.stringify(params), options);
export const getcarMonthLastEndTime = (params, options) =>
  request.get(
    '/api/v4ward/car/CarMonth/carMonthLastEndTime/v2',
    Object.assign({}, options, {
      params
    })
  );

export const saveCarCharge = (params, options) =>
  request.post('/api/v4ward/car/recharge/submit/v2', params, options);

export const carMonthRule = (params, options) =>
  request.get(
    '/api/v4ward/car/monthDiscountRule/carMonthRule/v2',
    Object.assign({}, options, {
      params
    })
  );
export const getPaySceneList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/car/recharge/getPayScene/v2",
    Object.assign({}, options, {
      params
    })
  );

export const queryCarCharge = (params, options) =>
  request.get('/api/v4ward/car/recharge/pay/query/v2', Object.assign({}, options, {
    params
  }));

export const getBuildingList = (params, options) =>
  request.get('/api/v4ward/car/property/getBuildingList', Object.assign({}, options, {
    params
  }));

export const getRoomList = (params, options) =>
  request.get('/api/v4ward/car/property/getRoomList', Object.assign({}, options, {
    params
  }));
  

  export const getCarRuleDiscountList = (params, options) =>
  request.get('/api/v4ward/carfeerulediscount/carRuleDiscountList', Object.assign({}, options, {
    params
  }));

  export const getManagefeedetailList = (params, options) =>
  request.get('/api/v4ward/car/managefeedetail/page', Object.assign({}, options, {
    params
  }));
  
  export const getCarParkingSpaceList = (params, options) =>
  request.get('/api/v4ward/car/parking/space/page', Object.assign({}, options, {
    params
  }));
  
    export const carManageCheckPay = (params, options) =>
      request.post('/api/v4ward/car/manage/checkPay', params, options);
    
  // export const getCarRuleDiscountList = (params, options) =>
  // request.get('/api/v4ward/carfeerulediscount/carRuleDiscountList', Object.assign({}, options, {
  //   params
  // }));
  